import { render, staticRenderFns } from "./docentePastel.vue?vue&type=template&id=4de9ce4a"
import script from "./docentePastel.vue?vue&type=script&lang=js"
export * from "./docentePastel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports